import AbstractBaseError from './AbstractBaseError';

export default class NotFoundException extends AbstractBaseError {
	name = 'NotFoundException';

	shouldBeReported = false;
}
